import React from "react";
import { MOCK_TNDS_PREVIEW_BULLETS, MOCK_TNDS_CARD_TITLE } from "../constants";
import BenefitBulletList from "./BenefitBulletList";

export default function BenefitPreviewCard({ onOpenBenefitSheet }) {
  return (
    <div className="fire-explosion__benefit-preview">
      <div className="fire-explosion__benefit-preview-head">
        <span className="fire-explosion__benefit-preview-title">
          {MOCK_TNDS_CARD_TITLE}
        </span>
      </div>
      <BenefitBulletList items={MOCK_TNDS_PREVIEW_BULLETS} />
      <button
        type="button"
        className="fire-explosion__benefit-preview-footer"
        onClick={onOpenBenefitSheet}
      >
        <span>Xem đầy đủ quyền lợi &amp; quy tắc bảo hiểm</span>
        <span className="fire-explosion__benefit-arrow" aria-hidden>
          &rsaquo;
        </span>
      </button>
    </div>
  );
}
